import PriceSuggest from './styled';

export default PriceSuggest;
